import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { Project } from '@/types'
import * as projectApi from '../../services/api/project'

interface ProjectState {
  projects: Project[]
  currentProject: Project | null
  loading: boolean
  error: string | null
}

const initialState: ProjectState = {
  projects: [],
  currentProject: null,
  loading: false,
  error: null,
}

export const fetchProjects = createAsyncThunk(
  'project/fetchProjects',
  async () => {
    console.log('fetchProjects called')
    const response = await projectApi.getProjects()
    console.log('fetchProjects response:', response)
    // projectApi.getProjects() 已經回傳 response.data，即 { success: true, data: { projects: [...] } }
    // 所以我們直接回傳 response，讓 action.payload 是 { success: true, data: { projects: [...] } }
    return response
  }
)

export const fetchProject = createAsyncThunk(
  'project/fetchProject',
  async (projectKey: string) => {
    const response = await projectApi.getProject(projectKey)
    return response
  }
)

export const createProject = createAsyncThunk(
  'project/createProject',
  async (projectData: { name: string; key: string; description?: string }) => {
    const response = await projectApi.createProject(projectData)
    return response
  }
)

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    setCurrentProject: (state, action) => {
      console.log('setCurrentProject called with:', action.payload)
      state.currentProject = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch projects
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false
        console.log('fetchProjects.fulfilled payload:', action.payload)
        // API 回傳結構: { success: true, data: { projects: [...] } }
        // projectApi.getProjects() 回傳 response.data，即 { success: true, data: { projects: [...] } }
        // 在 thunk 中我們回傳 response.data，所以 action.payload 是 { success: true, data: { projects: [...] } }
        // 所以我們需要存取 action.payload.data.projects
        state.projects = action.payload?.data?.projects || []
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || '載入專案失敗'
      })
      // Fetch single project  
      .addCase(fetchProject.fulfilled, (state, action) => {
        state.currentProject = action.payload?.data?.project || null
      })
      // Create project
      .addCase(createProject.fulfilled, (state, action) => {
        if (action.payload?.data?.project) {
          state.projects.push(action.payload.data.project)
        }
      })
  },
})

export const { clearError, setCurrentProject } = projectSlice.actions
export default projectSlice.reducer